import $ from './el.JsModules.js';

elabs.CollectionPdp = class {
  'use strict';
  constructor(element) {
    this.view = $(element);

    this.initSlider();

    elabs.documentElement.on('WINDOW_RESIZED_EVENT', () => this.handleResize());
  }
  initSlider() {
    this.swiperSlider = new Swiper(this.view.find('.swiper')[0], {
      slidesPerView: 'auto',
      speed: 700,
      spaceBetween: 10,
      observer: true,
      preventClicks: true,
      preventClicksPropagation: true,
      watchSlidesProgress: true,
      centeredSlides: true,
      loop: true,
      allowTouchMove: true,
      allowSlidePrev: true,
      allowSlideNext: true,
      watchOverflow: true,
      on: {
        afterInit: (swiper) => this.updateAllowTouchMove(swiper),
        resize: (swiper) => this.updateAllowTouchMove(swiper),
        observerUpdate: (swiper) => this.updateAllowTouchMove(swiper),
        slideChangeTransitionEnd: (swiper) => this.updateAllowTouchMove(swiper),
      },
    });

    this.view.find('.el-circular-nav-button--prev, .el-slideshow__image-nav-left-button').click(() => {
      this.swiperSlider.slidePrev();
    });

    this.view.find('.el-circular-nav-button--next, .el-slideshow__image-nav-right-button').click(() => {
      this.swiperSlider.slideNext();
    });
  }

  updateAllowTouchMove(swiper) {
    const allVisible = this.checkAllSlidesVisible(swiper);

    swiper.allowTouchMove = !allVisible;
    swiper.allowSlidePrev = !allVisible;
    swiper.allowSlideNext = !allVisible;
    this.toggleButtonDisplay(allVisible);
  }

  checkAllSlidesVisible(swiper) {
    const originalSlides = Array.from(swiper.slides).filter(
      (slide) => !slide.classList.contains('swiper-slide-duplicate'),
    );
    return originalSlides.every((slide) => slide.classList.contains('swiper-slide-fully-visible'));
  }

  handleResize() {
    this.swiperSlider.destroy(true, true);
    this.initSlider();
  }

  toggleButtonDisplay(allVisible) {
    if (allVisible) {
      this.view.find('.el-circular-nav-button').hide();
      return;
    }

    this.view.find('.el-circular-nav-button').show();
  }
};

// Initialise all Collection PDP
elabs.onJavascriptReady(function () {
  $('.el-collection-pdp').each(function (index, element) {
    new elabs.CollectionPdp(element);
  });
});
